import { initialPagination } from '@app/constants/pagination';
import { ITableData } from './CatchesPage';

export const tableDataInit: ITableData = {
  data: [],
  pagination: initialPagination,
  filterOptions: {
    uniqueWaterbodies: [],
    uniqueFishTypes: [],
    uniqueStatuses: [
      { value: 'retained', labelEn: 'Retained', labelDe: 'Behalten', labelFr: 'Retenu', labelIt: 'Ritenuto' },
      { value: 'released', labelEn: 'Released', labelDe: 'Freigelassen', labelFr: 'Relâché', labelIt: 'Rilasciato' },
    ],
  },
  loading: false,
  error: false,
};
